import React, { useEffect, useState } from "react";
import LoaderBar from "./LoaderBar";

const ModelContainer = ({
  title = "",
  open,
  closeModal,
  submitModal,
  updateModal,
  is_loading,
  save_btn_name = "Save",
  sec_save_btn_name = "Update",
  is_large = false,
  isExtraLarge = false,
  children,
}) => {
  // const displayStyle = open ? "block" : "none";

  if (open) document.body.classList.add("scroll-none");
  else if (!open) document.body.classList.remove("scroll-none");

  const [displayStyle, setDisplayStyle] = useState("none");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (open) {
      setDisplayStyle("block");
      setAnimate(true);
    } else {
      setAnimate(false);
      setTimeout(() => {
        setDisplayStyle("none");
      }, 500);
    }
  }, [open]);

  return (
    <div
      className={`modal forgotModal`}
      id="forgot_modal"
      tabIndex="-1"
      aria-labelledby="loginModalLabel"
      aria-hidden="true"
      style={{ display: displayStyle }}
    >
      <div
        className={`modal-dialog modal-${
          isExtraLarge === true ? "xl" : is_large == true ? "lg" : "md"
        } 
        modal-dialog-scrollable ${
          animate
            ? "animate__animated animate__faster animate__fadeInDownBig"
            : "animate__animated animate__fadeOutUpBig"
        }`}
      >
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => closeModal(false)}
            >
              <img src={`/img/circle-cross.svg`} />
            </button>
            <span className="titleName"> {title} </span>
          </div>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <div className="invt-btns button">
              {submitModal && (
                <button
                  type="button"
                  onClick={() => {
                    if (!is_loading) submitModal();
                  }}
                  className="btn SaveBtn"
                >
                  {is_loading ? (
                    <div class="spinner-border" role="status"></div>
                  ) : (
                    `${save_btn_name}`
                  )}
                </button>
              )}
              {updateModal && (
                <button
                  type="button"
                  onClick={() => {
                    if (!is_loading) updateModal();
                  }}
                  className="btn SaveBtn"
                >
                  {is_loading ? (
                    <div class="spinner-border" role="status"></div>
                  ) : (
                    `${sec_save_btn_name}`
                  )}
                </button>
              )}
              {closeModal && (
                <button
                  type="button"
                  className="btn btn-danger"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => closeModal(false)}
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelContainer;
